export default __webpack_public_path__ + "static/media/flow_icon.ea628e52.png";